import React, { useEffect, useMemo, useState } from "react";
import AdminTabelHeader from "../../components/layout/header/AdminTabelHeader";
import { useMutation, useQuery } from "react-query";
import axios from "axios";
import { MaterialReactTable } from "material-react-table";
import { BASEURL } from "../../../utils/BaseUrl";
import "./applicationdetails.css";

import { IoIosDocument } from "react-icons/io";
import TraingleLoading from "../../../common/Loading/TraingleLoading";

const ApplicationDetails = () => {
  const [allData, setAllData] = useState([]);
  const [inputValue, setInputValue] = useState("");
  const { data,isLoading } = useQuery({
    queryKey: "getAllApplications",
    queryFn: () =>
      axios.get(`${BASEURL}job-applications`).then((res) => {
        return res?.data;
      }),
  });

  useEffect(() => {
    if (data) {
      const reversedData = data?.sort((a, b) => b.id - a.id); 
      setAllData(reversedData);
    }
  }, [data]);

  const { data: jobs,isLoading:is1 } = useQuery({
    queryKey: "getAllJob",
    queryFn: () =>
      axios.get(`${BASEURL}job`).then((res) => {
        return res?.data;
      }),
  });

  const editMutation = useMutation({
    mutationFn: (values) => {
      return axios.put(`${BASEURL}job-status/${values?.id}`, values?.data);
    },
  });

  const handleUpdate = (id) => {
    const values = {
      id: id,
      data: {
        status: false,
      },
    };

    editMutation.mutate(values);
  };

  const columns = useMemo(
    () => [
      {
        accessorFn: (row, index) => (
          <p
            className={
              row?.original?.status === true ? "bold-row" : "normal-row"
            }
          >
            {index + 1}
          </p>
        ),
        id: "index",
        header: "S.No",
      },

      {
        id: "first_name",
        Cell: ({ row }) => (
          <>
            <p
              className={
                row.original.status === true ? "bold-row" : "normal-row"
              }
            >
              {row?.original?.first_name}
            </p>
          </>
        ),
        header: "First Name",
      },
      {
        id: "email",
        Cell: ({ row }) => (
          <>
            <p
              className={
                row.original.status === true ? "bold-row" : "normal-row"
              }
            >
              {row?.original?.email}
            </p>
          </>
        ),
        header: "Email",
      },
      {
        id: "phone",
        Cell: ({ row }) => (
          <>
            <p
              className={
                row.original.status === true ? "bold-row" : "normal-row"
              }
            >
              {row?.original?.phone}
            </p>
          </>
        ),
        header: "Phone",
      },
      {
        id: "qualification",
        Cell: ({ row }) => (
          <>
            <p
              className={
                row.original.status === true ? "bold-row" : "normal-row"
              }
            >
              {row?.original?.qualification}
            </p>
          </>
        ),
        header: "Qualification",
      },
      {
        id: "specialization",
        Cell: ({ row }) => (
          <>
            <p
              className={
                row.original.status === true ? "bold-row" : "normal-row"
              }
            >
              {row?.original?.specialization}
            </p>
          </>
        ),
        header: "Specialization",
      },
      {
        id: "country",
        Cell: ({ row }) => (
          <>
            <p
              className={
                row.original.status === true ? "bold-row" : "normal-row"
              }
            >
              {row?.original?.country}
            </p>
          </>
        ),
        header: "Country",
      },
      {
        id: "state",
        header: "State",
        Cell: ({ row }) => (
          <>
            <p
              className={
                row.original.status === true ? "bold-row" : "normal-row"
              }
            >
              {row?.original?.state}
            </p>
          </>
        ),
      },
      {
        id: "Applied",
        header: "Applied Date",
        Cell: ({ row }) => (
          <>
            <p
              className={
                row.original.status === true ? "bold-row" : "normal-row"
              }
            >
              {row?.original?.applied_at.slice(0, 10)}
            </p>
          </>
        ),
      },
      {
        id: "actions",
        header: "Actions",
        Cell: ({ row }) => (
          <>
            <div className="flex items-center justify-around">
              <a
                onClick={() => handleUpdate(row?.original?.id)}
                href={row?.original?.resume_path}
                target="_blank"
              >
                <IoIosDocument className="w-5 h-5 cursor-pointer mx-2" />
              </a>
            </div>
          </>
        ),
      },
    ],
    []
  );

  const handleOptionChange = async (e) => {
    console.log(e.target.value);
    
    setInputValue(e?.target?.value);
    if (e?.target?.value == 0) {
      setAllData(data);
    } else {
      try {
        const res = await axios.get(
          `${BASEURL}/job/${e?.target?.value}/application`
        );

        setAllData(res?.data);
      } catch (err) {}
    }
  };
  console.log(inputValue);

  return (
    <div>
      <div className="flex justify-between items-center pr-4">
        {
          (isLoading || is1) && <TraingleLoading />
        }
        <AdminTabelHeader title="Applicant Pool" btnStatus={false} />
        <select
          onChange={(e) => handleOptionChange(e)}
          value={inputValue}
          className="w-60 p-3  outline-none border-2 rounded-lg text-black"
        >
          <option value={0}>All Jobs</option>
          {jobs?.map((v, i) => {
            return <option value={v?.id}>{v?.title}</option>;
          })}
        </select>
      </div>
      <div className="p-4">
        <MaterialReactTable
          columns={columns}
          data={allData || []}
          enableColumnResizing
          enableColumnOrdering
        />
      </div>
    </div>
  );
};

export default ApplicationDetails;
